<template>
    <div>
        <div class="text-grey-darkest text-2xl pr-10 pb-8" style="line-height: 50px;">
                            <div class="mb-5" >

                                <b class="uppercase">I. Introduction</b>
                                <br>
                                This Privacy Policy is adopted in compliance Republic Act No. 10173 , otherwise known as
                                the “Data Privacy Act of 2012” (DPA), its Implementing Rules and Regulations (IRR), and
                                other relevant rules and policies, including issuances of the National Privacy
                                Commission (NPC).
                                This policy outlines the data protection and security measures adopted by the Philippine
                                Army Finance Center Producers Integrated Cooperative (PAFCPIC) to safeguard and protect
                                data privacy rights and shall serve as a guide in the exercise of rights under the DPA.
                            </div>
                            <div class="mb-6">
                                <b class="uppercase">II. Policy Statement</b>
                                <br>
                                We, at Philippine Army Finance Center Producers Integrated Cooperative (PAFCPIC), are
                                committed to provide you with quality and innovative services while implementing
                                safeguards
                                to protect your privacy and keep your personal information safe and secure in compliance
                                with the DPA. All officers and employees of PAFCPIC are enjoined to comply with and to
                                share
                                the responsibility to secure and protect personal information, including sensitive
                                personal
                                information, collected and processed by the Cooperative in pursuit of legitimate
                                purposes.
                            </div>
                            <div class="mb-6">
                                <b>III. Definition of Terms</b>
                                <br>
                                <ol type="A">
                                    <li>Data Subject refers to an individual whose personal, sensitive personal, or
                                        privileged information is processed.</li>
                                    <li>Personal information refers to any information whether recorded in a material
                                        form or
                                        not, from which the identity of an individual is apparent or can be reasonably
                                        and
                                        directly ascertained by the entity holding the information, or when put together
                                        with other
                                        information would directly and certainly identify an individual.</li>
                                    <li>Sensitive personal information refers to personal information:</li>
                                    <ol>
                                        <li>About an individual's race, ethnic origin, marital status, age, color, and
                                            religious,
                                            philosophical or political affiliations;</li>
                                        <li>About an individual's health, education, genetic or sexual life of a person,
                                            or to
                                            any proceeding for any offense committed or alleged to have been committed
                                            by such person,
                                            the disposal of such proceedings, or the sentence of any court in such
                                            proceedings;</li>
                                        <li>
                                            Issued by government agencies peculiar to an individual which includes, but
                                            not
                                            limited to, social security numbers, previous or cm-rent health records,
                                            licenses or its
                                            denials, suspension or revocation, and tax returns; and
                                        </li>
                                        <li> Specifically established by an executive order or an act of Congress to be
                                            kept
                                            classified.</li>
                                    </ol>
                                    <li>Processing refers to any operation or any set of operations performed upon
                                        personal
                                        information including, but not limited to, the collection, recording,
                                        organization,
                                        storage, updating or modification, retrieval, consultation, use, consolidation,
                                        blocking, erasure
                                        or destruction of data.</li>
                                    <li>Personal information controller refers to a person or organization who controls
                                        the
                                        collection, holding, processing or use of personal information, including a
                                        person or
                                        organization who instructs another person or organization to collect, hold,
                                        process,
                                        use, transfer or disclose personal information on his or her behalf.</li>
                                    <li>Data Protection Officer refers to an individual designated by the head of agency
                                        or
                                        organization to be accountable for its compliance with the DPA, its IRR, and
                                        other
                                        issuances
                                        of the NPC.</li>
                                </ol>
                            </div>

                            <div class="mb-6">
                                <b class="uppercase">IV. Processing of Personal Information</b>
                                <ol>
                                    <li>Collection of Personal Information</li>
                                    In the course of our transactions with data subjects, PAFCPIC may collect personal
                                    information including, but not limited to:
                                    <br>
                                    <ol>
                                        <li>Name, sex, civil status, residential address, date and place of birth, age,
                                            citizenship</li>
                                        <li>Parents' name, religion, nationality, date and place of birth, occupation,
                                            and other
                                            information in Birth Certificate</li>
                                        <li>Military serial number, rank, Tax Identification Number (TIN), GSIS or SSS
                                            number
                                        </li>
                                        <li>Employment status, occupation, service term, employer, office address</li>
                                        <li>Monthly and annual income, financial situation</li>
                                        <li>Contact numbers, e-mail address, and emergency contact information</li>
                                        <li>Spouse's name, date and place of birth, residence, citizenship, religion,
                                            parents
                                        </li>
                                        <li>Date and place of marriage, solemnizing officer, and other information in
                                            Marriage
                                            Certificate</li>
                                        <li>Name of legal beneficiaries and their personal information</li>
                                        <li>Medical condition and history</li>
                                        <li>Specimen signatures</li>
                                        <li>Scholastic and other academic records</li>
                                        <li>Date and place of death, cause of death, and other information in Death
                                            Certificate
                                        </li>
                                        <li>Images via CCTV and other similar recordings taken within office premises or
                                            during
                                            activities conducted out of office</li>
                                    </ol>
                                    <br>
                                    A data subject's personal information may be collected through the following ways:
                                    <ol>
                                        <li>Application for membership by filling out the required forms and submitting
                                            additional
                                            requirements</li>
                                        <li>Application for loans or other financial and integrated services by filling
                                            out the
                                            required forms and submitting additional requirements</li>
                                        <li>Interaction with our employees, either written or verbal, through
                                            face-to-face
                                            transactions, phone, e-mail, or social media inquiries</li>
                                        <li>Filling out of the required forms for inquiries, requests, comments, or
                                            complaints
                                        </li>
                                        <li>Participation in surveys, focus group discussions, marketing promotions, and
                                            other
                                            similar initiatives</li>
                                        <li>Submission of requirements for job application</li>
                                        <li>Submission of requirements for scholarship or other requests for assistance
                                        </li>
                                        <li>Recording of images and videos through CCTV within office premises</li>
                                        <li>Application for voluntary termination or deceased termination filed by legal
                                            beneficiaries by filling out the required forms and submitting additional
                                            requirements</li>
                                        <li>Other similar means</li>
                                    </ol>
                                    <br>
                                    <li>Use and Disclosure of Personal Information</li>
                                    PAFCPIC uses and discloses collected personal information for the following
                                    purposes:
                                    <ol>
                                        <li>To manage membership of individuals in the cooperative</li>
                                        <li>To provide quality financial and integrated products and services</li>
                                        <li>To provide assistance and feedback to members</li>
                                        <li>To communicate relevant services, advisories, promotions, including
                                            responses to
                                            queries, requests, and complaints</li>
                                        <li>To allow members to participate in promotional activities, special events,
                                            and
                                            community
                                            initiatives</li>
                                        <li>To undertake marketing and promotional campaigns</li>
                                        <li>To implement prevention, detection, and corrective measures in relation to
                                            fraud and
                                            other relevant risks</li>
                                        <li>To evaluate and process applications for employment</li>
                                        <li>To comply with the requirements of Republic Act 9510 (“Credit Information
                                            System
                                            Act”)
                                        </li>
                                        <li>To comply with the requirements of other relevant existing laws and legal
                                            proceedings
                                            such as court orders</li>
                                        <li>To comply with the legal obligation to prevent imminent harm to public
                                            security,
                                            safety,
                                            or order</li>
                                        <li>To utilize relevant data for research, analytical, and promotional purposes
                                        </li>
                                        <li>To undertake other similar legitimate purposes</li>
                                    </ol>
                                    <br>
                                    <li>Sharing of Personal Information to Third Parties</li>
                                    In the course of operations and providing services to members, PAFCPIC may engage
                                    the
                                    services of third parties. In instances when certain personal information is
                                    required to be
                                    disclosed to fulfill legitimate business concerns and as may be necessary to provide
                                    services, we shall exercise utmost diligence in processing your personal
                                    information.
                                    PAFCPIC will never share, sell, or otherwise disclose your personal information with
                                    third
                                    parties, except as otherwise indicated above, or unless otherwise permitted under
                                    the Data
                                    Privacy Act or other applicable laws and regulations.
                                    <br>
                                    <li>Accessing and Updating your Personal Information</li>
                                    Members may access and update personal information previously collected from them by
                                    proceeding to any of our PAFCPIC Satellite Offices (PSOs) and submitting a written
                                    request
                                    to authorized employees. This information will be available for members' access
                                    during
                                    business hours and after a reasonable period of time for us to prepare the same.
                                    <br>
                                    <li>Personal Information Retention and Disposal</li>
                                    The personal information of data subjects shall be retained by PAFCPIC only for as
                                    long as
                                    it is necessary to fulfill the purpose/s for which it was obtained and in accordance
                                    with
                                    the prescribed retention period depending on the nature of the personal information
                                    collected and subject to the specific retention policy of the department or section
                                    storing
                                    such information.
                                    Thereafter, the personal information shall be disposed of or de-identified in a
                                    secure
                                    manner sufficient to make the information non-personally identifiable in order to
                                    prevent
                                    further processing, unauthorized access, or unlawful disclosure to any other party.
                                </ol>
                            </div>

                            <div class="mb-6">
                                <b class="uppercase">V. Data Protection</b>
                                <br>
                                PAFCPIC implements reasonable and appropriate organizational, physical, and technical
                                security measures for the protection of personal information which we collected.
                                The security measures aim to maintain the availability, integrity, and confidentiality
                                of
                                personal information and are intended for the protection of personal information against
                                any
                                accidental or unlawful destruction, alteration, and disclosure, as well as against any
                                other
                                unlawful processing
                                In compliance with the DPA, PAFCPIC has appointed a Data Protection Officer (DPO) to
                                manage
                                and safeguard the processing of your personal information. A Data Privacy Section under
                                the
                                direct supervision of the DPO was also established for the same purpose. PAFCPIC commits
                                itself to ensuring that your personal information is secured and protected under the
                                standards provided for by law and in line with the best practices of the industry.
                                VI. Confidentiality
                                PAFCPIC employees process and hold personal information under strict confidentiality.
                                They
                                are required to sign non-disclosure agreements and are trained on the company's privacy
                                and
                                security policies to ensure confidentiality and security of your personal information.

                            </div>
                            <div class="mb-6">
                                <b class="uppercase">VII. Rights of the Data Subjects</b>
                                <br>
                                Data subjects are entitled to the following rights:
                                <ol type="A">
                                    <li>Be informed of when and how personal information shall be, is being or has been
                                        processed;</li>
                                    <li> Be furnished with the information indicated below before the entry of personal
                                        information into the processing system of the personal information controller,
                                        or at the
                                        next practical opportunity:</li>
                                    <ol>
                                        <li>Description of the personal information to be entered into the system;</li>
                                        <li>Purposes for which it is being or are to be processed;</li>
                                        <li>Scope and method of the personal information processing;</li>
                                        <li>The recipients or classes of recipients to whom it is or may be disclosed;
                                        </li>
                                        <li>Methods utilized for automated access, if the same is allowed by the data
                                            subject,
                                            and the extent to which such access is authorized;</li>
                                        <li>The identity and contact details of the personal information controller or
                                            its
                                            representative;</li>
                                        <li>The period for which the information will be stored; and</li>
                                        <li>The existence of their rights, i.e., to access, correction, as well as the
                                            right to
                                            lodge a complaint before the Commission.</li>
                                    </ol>

                                    Any information supplied or declaration made to the data subject on these matters
                                    shall not
                                    be amended without prior notification: Provided, That the notification under
                                    subsection (b)
                                    shall not apply should the personal information be needed pursuant to a subpoena or
                                    when the
                                    collection and processing are for reasonably apparent purposes, including when it is
                                    necessary for the performance of or in relation to a contract or service or when
                                    necessary
                                    or desirable in the context of an employer-employee relationship, or when the
                                    information is
                                    being collected and processed as a result of legal obligation;
                                    <br>
                                    <li>Reasonable access to, upon demand, the following:</li>
                                    <ol>
                                        <li>Contents of personal information that were processed;</li>
                                        <li>Sources from which personal information were obtained;</li>
                                        <li>Names and addresses of recipients of the personal information and sensitive
                                            personal information;</li>
                                        <li>Manner by which such data were processed;</li>
                                        <li>Reasons for the disclosure of the personal information to recipients;</li>
                                        <li>Information on automated processes where the data will or likely to be made
                                            as the sole basis for any decision significantly affecting or will affect
                                            the data subject;</li>
                                        <li>Date when personal information was last accessed and modified;</li>
                                        <li>The designation, or name or identity and address of the personal information
                                            controller (PIC).</li>
                                    </ol>

                                    <li>Dispute the inaccuracy or error in the personal information and have the
                                        personal
                                        information controller correct it immediately and accordingly, unless the
                                        request is
                                        vexatious or otherwise unreasonable. If the personal information has been
                                        corrected,
                                        the PIC shall ensure the accessibility of both the new and the retracted
                                        information and the
                                        simultaneous receipt of the new and the retracted information by recipients
                                        thereof:
                                        Provided, That the third parties who have previously received such processed
                                        personal information shall be informed of its inaccuracy and its rectification
                                        upon request
                                        of the data subject;</li>
                                    <li>Suspend, withdraw or order the blocking, removal or destruction of personal
                                        information from the PIC's filing system upon discovery and substantial proof
                                        that the personal
                                        information are incomplete, outdated, false, unlawfully obtained, used for
                                        unauthorized purposes or are no longer necessary for the purposes for which they
                                        were collected;
                                        and</li>
                                    <li>Be indemnified for any damages sustained due to such inaccurate, incomplete,
                                        outdated, false, unlawfully obtained or unauthorized use of personal
                                        information.</li>
                                    <li>Where personal information is processed by electronic means and in a structured
                                        and commonly used format, data subjects have the right to obtain from the PIC a
                                        copy of
                                        data undergoing processing in an electronic or structured format, which is
                                        commonly used
                                        and allows for further use.</li>

                                </ol>
                            </div>
                            <div class="mb-6">
                                <b class="uppercase">VIII. Amendments and Updates to Privacy Policy</b>
                                <br>
                                PAFCPIC reserves the right to regularly update and amend its Privacy Policy, as needed,
                                to comply with legal and regulatory requirements, to reflect changes in the
                                Cooperative's
                                processes and procedures, to align with industry practice, to adopt new technologies and
                                methodologies, or for other legitimate purposes. Any significant updates or amendments
                                to the Privacy Policy shall be duly communicated and disseminated to all concerned
                                parties.
                            </div>
                            <div>
                                <b class="uppercase">IX. Contact Information</b>
                                <br>
                                If you have further questions or concerns, you may contact our Data Protection Officer
                                through the following details:
                                
                                Contact Number: (02) 8844-9010 loc. 310
                                <br>
                                Email Address: dpo.pafcpic@gmail.com
                                <br>
                            </div>
                            <b class="text-grey-dark">PAFCPIC © 2023</b>
                            <div class="flex items-center justify-center align-middle mt-5">
                                <img :src="getImage('privacy_seal')" style="width: 15rem;">
                            </div>
                        </div>
    </div>
</template>

<script>
import mixin from '@/mixins/controls.js';

export default {
    name: 'v-icon',
    mixins: [mixin],
    props: {
        
    },
    
}
</script>
